module.exports = __webpack_public_path__ + "static/media/athenasLoginImage.54569d68.png";